// extracted by css-extract-rspack-plugin
export default {"UnformattedTextInfo":"Ob42L","DownloadButton":"xz3JF"};